import React from 'react';
import {
  Grid, List, ListItem, Typography, useTheme,
} from '@mui/material';
import { useSelector } from 'react-redux';

export default function UserGuides() {
  const brokerCode = useSelector((state) => state.auth?.brokerCode);
  const carrierCode = useSelector((state) => state.auth.carrierCode);
  const { palette } = useTheme();

  const getLatestUserGuide = () => {
    if (brokerCode) {
      return '/Ceres-User-Guide-09-2025-Broker.pdf';
    }
    if (carrierCode === 'AFLAC') {
      return '/Ceres-User-Guide-09-2025-Carrier-AFLAC.pdf';
    }
    return '/Ceres-User-Guide-09-2025-Carrier.pdf';
  };

  return (
    <Grid container spacing={2} padding={3}>
      <Grid item xs={12}>
        <Typography variant="h4">
          User Guides
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <List sx={{ listStyleType: 'disc', listStylePosition: 'inside' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <a
              href="/Ceres-User-Guide-12-2024.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: palette.primary.dark }}
            >
              Ceres-User-Guide-12-2024.pdf
            </a>
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <a
              href={brokerCode ? '/Ceres-User-Guide-06-2025-Broker.pdf' : '/Ceres-User-Guide-06-2025-Carrier.pdf'}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: palette.primary.dark }}
            >
              Ceres-User-Guide-06-2025.pdf
            </a>
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <a
              href={getLatestUserGuide()}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: palette.primary.dark }}
            >
              Ceres-User-Guide-09-2025.pdf
            </a>
          </ListItem>
        </List>
      </Grid>
    </Grid>
  );
}
